<template>
  <div>
    <section class="product-filter-list">
      <div class="container">
        <product-filters @filter-changed="$refs.productList.filterProducts($event)"/>
        <product-list ref="productList" inline-template>
          <div class="product-list">
            <div class="row">
              <div v-for="product in products" :key="product.id" class="col-6 col-md-3 product" data-aos="fade-in">
                <router-link :to="{ name: 'product', params: { slug: product.slug }}" :title="'Link: ' + product.title">
                  <img v-if="product.images.length > 0" v-bind:src="product.images[0].url" class="img-fluid"
                       :alt="'Image: ' + product.title"/>
                  <p>{{ product.title }}</p>
                </router-link>
                <span v-bind:class="['favourite', {
                    'active' : $root.isProductInBasket(product.id)
                  }]" v-on:click="toggleProductInBasket($event, product.id)"
                      title="Add or remove from favourites"></span>
              </div>
            </div>
            <ul v-if="totalPages > 1" class="pagination justify-content-center">
              <li v-for="index in totalPages" :key="index" class="page-item">
                <a v-on:click="page(index)"
                   v-bind:class="['page-link', { 'active' : index === pageNumber }]">{{index}}</a>
              </li>
            </ul>
          </div>
        </product-list>
      </div>
    </section>
  </div>
</template>

<script>
  import ProductFilters from "./ProductFilters";
  import ProductList from "./ProductList";

  export default {
    name: 'ProductFilterList',
    components: {
      ProductFilters,
      ProductList
    }
  }
</script>
